import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  id: string;
}
export function Input({
  label,
  error,
  id,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-1231">
      {label && <label htmlFor={id} className="block text-sm font-medium text-foreground mb-1.5" data-id="element-1232">
          {label}{' '}
          {props.required && <span className="text-destructive" data-id="element-1233">*</span>}
        </label>}
      <input id={id} className={`
          flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background 
          file:border-0 file:bg-transparent file:text-sm file:font-medium 
          placeholder:text-muted-foreground 
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 
          disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-destructive focus-visible:ring-destructive' : ''}
          ${className}
        `} {...props} data-id="element-1234" />
      {error && <p className="mt-1 text-xs text-destructive" data-id="element-1235">{error}</p>}
    </div>;
}